import React from "react";

function RelatedQuestions() {
  return (
    <div>
      Related Questions
    </div>
  )
}

export default RelatedQuestions;
